export { default } from './useAnimatedPlaceholder'
